<template>
  <div :class="$style['learning-center-news-tab-wrapper']">
    <div
      v-if="newsItems.length"
      :class="[$style['news-list'], showTopGradient ? $style.haze : '']"
    >
      <div
        ref="newsList"
        :class="$style['news-list-scroll']"
        class="gantt_scroll"
        @scroll="handleScroll"
      >
        <learning-center-news-card
          v-for="(newsItem, index) in newsItems"
          :key="newsItem.idTemplate"
          :news-item="newsItem"
          :is-latest="hasUnreadNews && index === 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import constants from '$$helpers/constants';
import { api } from '$$store/api';
import LearningCenterNewsCard from './learningCenterNewsCard.vue';

export default {
  name: 'LearningCenterNewsTab',
  components: {
    LearningCenterNewsCard,
  },
  props: {
    hasUnreadNews: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newsItems: [],
      showTopGradient: false,
      hasMarkedAsViewed: false,
    };
  },
  created() {
    api.get('/newshistory', {
      params: {
        start: 0,
        count: 1000,
      },
    })
      .then(({ data }) => {
        const { data: newsItems } = data;
        const sortedItems = newsItems.sort((a, b) => b.idTemplate - a.idTemplate);
        this.newsItems = sortedItems.map(this.extractAndSetImageUrl);
        this.$nextTick(() => {
          const list = this.$refs.newsList;
          if (list) {
            this.showTopGradient = list.scrollTop > 0;
          }
        });
      })
      .catch((error) => {
        console.error('[LearningCenterNews] Load failed:', error);
      });
  },
  watch: {
    hasUnreadNews(newVal) {
      if (newVal && !this.hasMarkedAsViewed) {
        this.markNewsAsViewed();
      }
    },
  },
  mounted() {
    if (this.hasUnreadNews) {
      this.markNewsAsViewed();
    }
  },
  methods: {
    handleScroll(event) {
      const target = event.target;
      this.showTopGradient = target.scrollTop > 0;
    },
    markNewsAsViewed() {
      if (this.hasUnreadNews && !this.hasMarkedAsViewed) {
        this.hasMarkedAsViewed = true;
        this.$store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.LAST_NEWS_ID, status: window.user.lastNewsEntryId },
        ).then(() => {
          this.$parent.$forceUpdate();
        });
      }
    },
    extractAndSetImageUrl(newsItem) {
      const imageSrcMatch = newsItem.content.match(/<news-image>.+<\/news-image>/);

      if (imageSrcMatch?.length) {
        const [imageSrcString] = imageSrcMatch;

        newsItem.content = newsItem.content.replace(imageSrcString, '');
        newsItem.imageSrc = imageSrcString
          .replace('<news-image>', '')
          .replace('</news-image>', '');
      }

      if (!newsItem.imageSrc) {
        const imgTagRegExp = /<img[^>]+src="([^"]+)"[^>]*>/gi;
        let match;
        let lastImgTag = null;
        let lastImgSrc = null;

        while ((match = imgTagRegExp.exec(newsItem.content)) !== null) {
          lastImgTag = match[0];
          lastImgSrc = match[1];
        }

        if (lastImgSrc) {
          newsItem.content = newsItem.content.replace(/<img[^>]*>/gi, '');
          newsItem.imageSrc = lastImgSrc;
        }
      }

      const newsVideoTagMatch = newsItem.content.match(/<news-video.+\/>/);

      if (newsVideoTagMatch?.length) {
        const [newsVideoTagString] = newsVideoTagMatch;

        newsItem.content = newsItem.content.replace(newsVideoTagString, '');

        const requiredDataAttributes = ['data-video-src', 'data-video-id', 'data-video-class'];
        const videoDataAttributes = requiredDataAttributes.reduce((dataAttributesResult, dataAttributeName) => {
          const regExpToFindDataAttributeValue = new RegExp(`${dataAttributeName}="(.*?)"`, 'i');
          const findResult = regExpToFindDataAttributeValue.exec(newsVideoTagString);

          if (findResult?.length) {
            const [_, dataAttributeValue] = findResult;

            return { ...dataAttributesResult, ...{ [dataAttributeName]: dataAttributeValue } };
          }

          return dataAttributesResult;
        }, {});

        const isEveryRequiredDataAttributesParsed = Object.values(videoDataAttributes).filter(Boolean).length === requiredDataAttributes.length;

        if (!isEveryRequiredDataAttributesParsed) {
          console.warn('[LearningCenterNews] Missing required video data attribute');

          return newsItem;
        }

        newsItem.videoData = videoDataAttributes;
      }

      return newsItem;
    },
  },
};
</script>

<style module src="./learningCenterNewsTab.less" lang="less">
</style>
